import { render, staticRenderFns } from "./OrderDocumentTable.vue?vue&type=template&id=420de57e&"
import script from "./OrderDocumentTable.vue?vue&type=script&lang=ts&"
export * from "./OrderDocumentTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports